<template>
  <div id="bottom-nav">
    <div class="container">
      <ul class="bottom-nav">
        <li v-if="isStandard">
          <router-link class="link" to="/">
            <i class="fal fa-home"></i>
            <p>Home</p>
          </router-link>
        </li>
        <li v-if="isStandard">
          <router-link class="link" :to="{ name: 'Settings' }">
            <i class="fal fa-cogs"></i>
            <p>Settings</p>
          </router-link>
        </li>
        <li v-if="isAdmin">
          <router-link class="link" :to="{ name: 'Admin' }">
            <i class="fal fa-users-cog"></i>
            <p>Admin</p>
          </router-link>
        </li>
        <li v-if="isAdmin">
          <a class="link" @click="uploadDocument()">
            <i class="fal fa-arrow-to-top"></i>
            <p>Upload</p>
          </a>
        </li>
        <li v-if="isStandard">
          <div @click="logout" class="link">
            <i class="fal fa-sign-out-alt"></i>
            <p class="link">Logout</p>
          </div>
        </li>
      </ul>
      <!-- <div class="search">
        <i class="fal fa-search"></i>
        <input type="search" placeholder="Search..." />
      </div> -->
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import { getUserInfo } from "../mixins/getUserInfo";
export default {
  name: "BottomNav",
  mixins: [getUserInfo],
  methods: {
    uploadDocument() {
      this.$emit("openUploadModal");
    },
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          if (navigator.userAgent.indexOf("Safari") != -1) {
            this.$router.go({ path: this.$router.path });
            window.location.reload();
          } else {
            this.$router.go({ path: this.$router.path });
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
#bottom-nav {
  background-color: white;

  .container {
    display: flex;
  }

  .search {
    position: relative;
    flex: 1;
    padding: 1rem 0;
    display: flex;
    justify-content: flex-end;

    i {
      position: absolute;
      top: 25px;
      right: 10px;
    }

    input {
      transition: 300ms ease;
      border-radius: 5px;
      border: 1px solid #979797;
      width: 50%;
      padding: 0.5rem;
    }

    input:focus {
      outline: none;
      border-color: #6236ff;
    }
  }

  .bottom-nav {
    flex: 2;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media (min-width: 700px) {
      flex-direction: row;
      align-items: initial;
    }

    li {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 1rem 1rem;
      margin-right: 1rem;
      text-align: center;
      transition: 500ms ease;
      border-bottom: 1px solid transparent;

      &:hover {
        border-color: #6236ff;
      }
    }

    i {
      margin-right: 0.3rem;
      color: #5c5c5c;
    }

    .link {
      cursor: pointer;
      display: flex;
      align-items: center;
      color: #5c5c5c;
      text-decoration: none;
    }
  }
}
</style>
